import { eventCatalog } from '@highereducation/eventing/catalog';

export const EDU_EVENT_APP_NAME = 'Dynamic-Experiences-V2';
export const EDU_EVENT_ORIGINAL_EMITTER = 'Dynamic-Experiences-App';

export const eventMap: Record<string, string> = Object.fromEntries(
  Object.entries(eventCatalog.events).map(([name, event]) => [
    name,
    event.schema,
  ]),
);
